module.exports = __webpack_public_path__ + "static/media/maestrotak.1861e8fd.jpg";